var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import ReadOnlyPartRow from "../../components/readonlymode/readonlypartrow.vue";
import { clone, isInstanceOf, isRootIdKey, isVertexKey, } from "../utilities/aux";
import { Column, createDisplayProject, sortDisplayProject, isRowDisplayInformation, } from "../utilities/projecttable";
import { isArray, isBoolean, isString, } from "../utilities/wsi4_typeguards";
function isReadOnlyViewPart(arg) {
    const typeGuardMap = {
        displayInfo: isRowDisplayInformation,
        deleted: isBoolean,
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isReadOnlyViewAssembly(arg) {
    const typeGuardMap = {
        assemblyRootIdKey: isRootIdKey,
        assemblyVertexKey: isVertexKey,
        articleName: isString,
        parts: (t) => isArray(t, isReadOnlyViewPart),
    };
    return isInstanceOf(arg, typeGuardMap);
}
let ReadOnlyView = class ReadOnlyView extends Vue {
    constructor() {
        super(...arguments);
        this.singlePartViewEntries = [];
        this.assemblyViewEntries = [];
    }
    close() { }
    openPartCreationSelection() { }
    onNextButtonClicked() {
        const verticesToDelete = [
            ...this.singlePartViewEntries.reduce((res, spve) => {
                if (spve.deleted) {
                    res.push(spve.displayInfo.vertexKey);
                }
                return res;
            }, []),
            ...this.assemblyViewEntries.reduce((res, ave) => {
                const partsDeleted = ave.parts.filter(p => p.deleted);
                if (ave.parts.length === partsDeleted.length) {
                    res.push(ave.assemblyVertexKey);
                }
                return [
                    ...res,
                    ...partsDeleted.map(p => p.displayInfo.vertexKey),
                ];
            }, []),
        ];
        if (!this.networkBroker.queueDeleteRequest(verticesToDelete)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
        this.close();
    }
    handleSinglePartDeletion(vertexKey) {
        const singleParts = clone(this.singlePartViewEntries, (arg) => isArray(arg, isReadOnlyViewPart));
        const index = singleParts.findIndex(p => p.displayInfo.vertexKey === vertexKey);
        if (index === -1) {
            throw Error("Missing vertexKey.");
        }
        singleParts[index].deleted = !singleParts[index].deleted;
        this.singlePartViewEntries = singleParts;
    }
    handlePartDeletion(assemblyIndex, vertexKey) {
        const assemblies = clone(this.assemblyViewEntries, (arg) => isArray(arg, isReadOnlyViewAssembly));
        const dIndex = assemblies[assemblyIndex].parts.findIndex(p => p.displayInfo.vertexKey === vertexKey);
        if (dIndex === -1) {
            throw Error("Missing vertexKey");
        }
        assemblies[assemblyIndex].parts[dIndex].deleted = !assemblies[assemblyIndex].parts[dIndex].deleted;
        this.assemblyViewEntries = assemblies;
    }
    setViewEntries(oldSinglePartViewEntries, oldAssemblyViewEntries) {
        this.singlePartViewEntries = this.displayProject.singleParts.map(s => {
            const old = oldSinglePartViewEntries.find(e => e.displayInfo.rootIdKey === s.rootIdKey);
            return {
                displayInfo: s,
                deleted: old !== undefined ? old.deleted : false,
            };
        });
        this.assemblyViewEntries = this.displayProject.assemblies.map(a => {
            const old = oldAssemblyViewEntries.find(e => e.assemblyRootIdKey === a.assembly.rootIdKey);
            const partDeleted = (rootIdKey) => {
                if (!old) {
                    return false;
                }
                const oldPart = old.parts.find(e => e.displayInfo.rootIdKey === rootIdKey);
                return oldPart !== undefined ? oldPart.deleted : false;
            };
            return {
                assemblyVertexKey: a.assembly.vertexKey,
                assemblyRootIdKey: a.assembly.rootIdKey,
                articleName: a.assembly.articleName,
                parts: a.parts.map(p => ({
                    displayInfo: p,
                    deleted: partDeleted(p.rootIdKey),
                })),
            };
        });
    }
    get numberOfColumns() {
        const map = {
            png: null,
            svg: null,
            articleName: null,
            thickness: null,
            deleted: null,
            status: null,
        };
        return (Object.keys(map).length - 1) + 1;
    }
    get displayProject() {
        return sortDisplayProject(createDisplayProject(this.project, this.networkBroker.configuration.priceFactors, this.i18n, this.shopConfig, []), {
            columnName: Column.articleName,
            up: true,
        });
    }
    created() {
        this.setViewEntries([], []);
    }
    onProjectChanged() {
        this.setViewEntries(this.singlePartViewEntries, this.assemblyViewEntries);
    }
};
__decorate([
    Prop({ required: true })
], ReadOnlyView.prototype, "project", void 0);
__decorate([
    Prop({ required: true })
], ReadOnlyView.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], ReadOnlyView.prototype, "showPartCreationButton", void 0);
__decorate([
    Inject()
], ReadOnlyView.prototype, "i18n", void 0);
__decorate([
    Inject()
], ReadOnlyView.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ReadOnlyView.prototype, "close", null);
__decorate([
    Emit()
], ReadOnlyView.prototype, "openPartCreationSelection", null);
__decorate([
    Watch("project")
], ReadOnlyView.prototype, "onProjectChanged", null);
ReadOnlyView = __decorate([
    Component({
        components: {
            ReadOnlyPartRow,
        },
        name: "ReadOnlyView",
    })
], ReadOnlyView);
export default ReadOnlyView;
